import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
type discountDTO = {
  discountPrecentage: number;
};
type discountResponse = object;
type ChangeStudentImgParams = {
  id: string;
  payload: discountDTO;
};

export const AddBookDiscount = async ({
  id,
  payload,
}: ChangeStudentImgParams): Promise<discountResponse> => {
  try {
    const response = await axios.patch(`/book/discount/${id}`, payload);
    return { data: response.data };
  } catch (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error: any
  ) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
